import { ICartEntry } from 'features/cart/types';
import { calculateEntryTotalPrice } from 'features/cart/utils';
import { StyleSheet, Text, View } from 'react-native';

import { useUIContext } from 'state/ui';
import { primitive } from 'styles/constants/primitives';

import {
  CartEntryDeleteButton,
  CartEntryDuplicateButton,
  CartEntryEditButton,
} from './cart-entry-action-buttons';

export const CartEntryFooter = ({
  cartEntry,
  isLoading,
}: {
  cartEntry: ICartEntry;
  isLoading?: boolean;
}) => {
  const { formatCurrencyForLocale } = useUIContext();

  return (
    <View style={styles.footer}>
      <CartEntryDeleteButton cartEntry={cartEntry} disabled={isLoading} variant="iconOnly" />
      <CartEntryDuplicateButton cartEntry={cartEntry} disabled={isLoading} />

      <CartEntryEditButton cartEntry={cartEntry} disabled={isLoading} />

      <View style={{ flex: 1 }} />
      <Text style={styles.editText}>
        {formatCurrencyForLocale(calculateEntryTotalPrice(cartEntry))}
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  footer: {
    flexDirection: 'row',
    paddingHorizontal: 16,
    paddingVertical: 8,
    borderTopWidth: 1,
    borderTopColor: primitive.$blackOpacity10,
    alignItems: 'center',
    gap: 16,
  },
  editText: {
    fontSize: 14,
    fontWeight: 'bold',
    fontFamily: primitive.fontFamily.$headers,
    color: primitive.bk.$bbqBrown,
  },
});
